module.exports = __webpack_public_path__ + "static/DE-6f03afb0600c48bdcc56fb532a1e4131.svg";